import { AxiosError } from 'axios'

export const jobNumberMaxLength = 15

export const detailsSaveErrorMessage = (error: unknown): string | undefined => {
  const data = (error as AxiosError<{ error?: string }>)?.response?.data
  return typeof data?.error === 'string' && data.error.trim() !== '' ? data.error : undefined
}
